export const SUBSCRIPTION_TYPE_PROVIDER = "provider"
export const SUBSCRIPTION_TYPE_CORPORATE = "corporate"
